import WorkflowProgressRepositoryError from './workflow-progress-repository-error'

const createLegacyDoneStepsProgressRepository = ({ requestId, receivedRequestProvider }) => {
    if (!requestId || typeof receivedRequestProvider !== 'function') {
        throw new WorkflowProgressRepositoryError(
            'INVALID_LEGACY_PROGRESS_REPOSITORY_DEPENDENCIES',
            'Legacy progress repository requires requestId and receivedRequestProvider()',
        )
    }

    const getRequestProvider = () => receivedRequestProvider(requestId)

    return Object.freeze({
        async getProgress() {
            const requestProvider = getRequestProvider()
            const doneSteps = requestProvider.request && requestProvider.request.doneSteps

            return {
                completedStepIds: [],
                completedLegacyPersistedSteps: Array.isArray(doneSteps) ? [...doneSteps] : [],
            }
        },
        markCompleted({ legacyPersistedStep }) {
            if (!Number.isInteger(legacyPersistedStep) || legacyPersistedStep < 1) {
                return Promise.reject(new WorkflowProgressRepositoryError(
                    'MISSING_LEGACY_PERSISTED_STEP',
                    'Legacy progress cannot persist a step without legacy.persistedStep',
                    { legacyPersistedStep },
                ))
            }

            const requestProvider = getRequestProvider()

            if (requestProvider.isStepDone(legacyPersistedStep)) {
                return Promise.resolve()
            }

            requestProvider.markStepAsDone(legacyPersistedStep)

            return Promise.resolve()
                .then(() => requestProvider.save())
                .catch(error => {
                    requestProvider.markStepAsUnDone(legacyPersistedStep)
                    throw error
                })
        },
    })
}

export { createLegacyDoneStepsProgressRepository }
export default createLegacyDoneStepsProgressRepository
